
import { MAData } from "@/models/ma/MAData"
import { defineComponent, PropType, ref } from "vue"
import Modal from "../shared/Modal.vue"
import MAHubspotForm from "./MAHubspotForm.vue"
import MAMarketoForm from "./MAMarketoForm.vue"
import MAPardotForm from "./MAPardotForm.vue"
import MADynamics365Form from "./MADynamics365Form.vue"
import { v4 as uuid } from "uuid"

export default defineComponent({
  components: { Modal, MAMarketoForm, MAHubspotForm, MAPardotForm, MADynamics365Form },
  props: {
    ma: Object as PropType<MAData>,
    formScript: String
  },
  setup(props) {
    let modal = ref<InstanceType<typeof Modal>>()
    let key = ref(uuid())
    let shown = ref(false)
    var callback: (() => void) | undefined = undefined
    let formTitle = !props.ma?.gate_after || props.ma.gate_after == 0 ? "Watch Video" : "Continue Watching Video"
    const showModal = (cb: () => void) => {
      if(shown.value === true) return
      key.value = uuid()
      shown.value = true
      modal.value?.showModal()
      callback = cb
    }

    const hideModal = ()=> {
      shown.value = false
      modal.value?.hideModal()
    }
    const formSubmitted = () => {
      hideModal()
      if (callback) callback()
    }

    return {
      key,
      showModal,
      hideModal,
      modal,
      formSubmitted,
      formTitle,
      shown
    }
  }
})
